module.exports = __webpack_public_path__ + "Flag-426.9c13f178eb385da077cd78a176c9ea42.svg";